import { Reveal } from "@components/ui";

const benefits = [
  {
    number: "01",
    title: "Competitive Salary Packages",
    description:
      "Aligned with UAE market standards and reviewed annually.",
  },
  {
    number: "02",
    title: "Medical Insurance",
    description:
      "Comprehensive coverage for staff (and dependents depending on role).",
  },
  {
    number: "03",
    title: "Annual Leave & Public Holidays",
    description:
      "Full compliance with UAE Labour Law in respect to leave and holiday.",
  },
  {
    number: "04",
    title: "Professional Certifications Support",
    description:
      "We sponsor certifications such as: DCD Technician License, ESMA Compliance Courses, LPG/SNG Engineering Certifications, HSE & ISO training",
  },
  {
    number: "05",
    title: "Career Growth Opportunities",
    description:
      "Internal promotion policy and leadership pipeline for high performers.",
  },
  {
    number: "06",
    title: "Performance Bonuses",
    description:
      "Based on KPI achievements, safety scores, and customer satisfaction ratings.",
  },
];

const WhatWeOfferSection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-[120px] bg-[#f1f1f1] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <Reveal>
          <div className="flex flex-col items-center text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#f24d2b]/10 text-[#f24d2b] text-[14px] md:text-[16px] font-medium tracking-[-0.04em] mb-4">
              Benefits
            </span>
            <h2 className="text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63]">
              What We Offer
            </h2>
            <p className="text-[20px] md:text-[24px] lg:text-[28px] text-[#62636c] tracking-[-0.04em] mt-3 max-w-[700px]">
              Employee Benefits are as follows
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <Reveal key={index} className="h-full">
              <div className="group relative overflow-hidden rounded-[24px] border border-[rgba(98,99,108,0.2)] bg-white p-6 md:p-8 flex flex-col items-center text-center hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] hover:border-[#e8e9ed] transition-all duration-300 h-full">
                {/* Watermark number */}
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[120px] md:text-[160px] font-bold text-[#f5f5f7] leading-none select-none pointer-events-none group-hover:text-[#ededf0] transition-colors duration-300">
                  {benefit.number}
                </span>

                {/* Number circle */}
                <div className="relative z-10 w-11 h-11 rounded-full bg-[#f03813] text-white text-[20px] font-semibold flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                  {benefit.number}
                </div>

                <h3 className="relative z-10 text-[20px] md:text-[24px] font-semibold text-[#090d2c] tracking-[-0.04em] text-center mb-2">
                  {benefit.title}
                </h3>
                <p className="relative z-10 text-[16px] md:text-[20px] text-[rgba(10,14,46,0.75)] tracking-[-0.04em] text-center">
                  {benefit.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeOfferSection;
